<template>
  <button @click="chooseExportForm = true" class="btn btn-outline-gray btn-sm is-border-1 mr-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="chooseExportForm" title="Chọn loại form để xuất dữ liệu" @ok="exportTransaction">
      <form-radio-group :stacked="true" :model="exportOptionModel" attribute="formType" errors="formErrors"
                        label="Chọn loại form"
                        :options="exportFormOptions"></form-radio-group>
    </b-modal>
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>


<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';
import provinceData from "@/views/1022/vn-adm.json";

export default {
  name: "CallFeeExport",
  props: ['filter', 'totalCount', 'getType'],
  data() {
    return {
      service: '/issue',
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0,
      provinceData,
      chooseExportForm: false,
      exportOptionModel: {
        formType: 3
      },
      exportFormOptions: [
        {value: 1, text: 'Form 1 (HT-YP gửi Be)'},
        {value: 2, text: 'Form 2 (Gửi các đơn vị khác)'},
        {value: 3, text: 'Form 3 (Tổng hợp)'},
        {value: 4, text: 'Form 4 (Tổng hợp)'}
      ]
    }
  },
  methods: {
    getProvinceDistrictWard(provinceCode, districtCode, wardCode) {
      let result = {
        province: 'Không rõ',
        district: 'Không rõ',
        ward: 'Không rõ'
      }
      if (provinceCode) {
        let province = this.provinceData.find(p => parseInt(p.value) === provinceCode);
        if (province) {
          result.province = province.text;
          let district = province.districts.find(d => parseInt(d.value) === districtCode);
          if (district) {
            result.district = district.text;
            let ward = district.wards.find(w => parseInt(w.value) === wardCode);
            if (ward) {
              result.ward = ward.text;
            }
          }
        }
      }
      return result;
    },
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet;
      switch (this.exportOptionModel.formType) {
        case 1:
          sheet = workbook.addWorksheet('Form 1 HT-YP');
          sheet.columns = [
            {header: "Số phiếu", key: 'no', width: 15},
            {header: "Ngày phản ánh", key: 'created_day', width: 15},
            {header: "Giờ nhận", key: 'created_hour', width: 15},
            {header: "Họ tên người cần hỗ trợ", key: 'needer_name', width: 15},
            {header: "Số điện thoại của người cần hỗ trợ", key: 'needer_phone', width: 15},
            {header: "Số lượng người/Hộ đang gặp khó khăn", key: 'peopleCount', width: 15},
            {header: "Quận/huyện", key: 'district', width: 15},
            {header: "Phường/xã", key: 'ward', width: 15},
            {header: "Địa chỉ người cần hỗ trợ", key: 'supportAddress', width: 15},
            {header: "Nhu yếu phẩm bạn cần hỗ trợ gì?", key: 'htyp', width: 30},
            {header: "Các thông tin khác", key: 'other', width: 30},
            {header: "Thông tin khác", key: 'otherInfo', width: 30},
            {header: "Người cần hỗ trợ có cần hỗ trợ gấp hay không?", key: 'emergency', width: 15},
            {header: "Có nằm trong vùng phong tỏa hay không", key: 'blockadeArea', width: 30},
          ];
          break;
        case 2:
          sheet = workbook.addWorksheet('Form 2');
          sheet.columns = [
            {header: "Số phiếu", key: 'no', width: 15},
            {header: "Ngày phản ánh", key: 'created_day', width: 15},
            {header: "Giờ nhận", key: 'created_hour', width: 15},
            {header: "Họ tên người cần hỗ trợ", key: 'needer_name', width: 15},
            {header: "Số điện thoại của người cần hỗ trợ", key: 'needer_phone', width: 15},
            {header: "Nội dung", key: 'content', width: 15},
            {header: "Vấn đề cần hỗ trợ (Mô tả cụ thể bằng lời)", key: 'content2', width: 30},
            {header: "Quận/huyện", key: 'district', width: 15},
            {header: "Phường/xã", key: 'ward', width: 15},
            {header: "Địa chỉ người cần hỗ trợ", key: 'supportAddress', width: 15},
            {header: "Nhu cầu cần hỗ trợ", key: 'type', width: 15},
            {header: "Trạng thái", key: 'status', width: 15},
            {header: "Ngày xử lý", key: 'ok_time', width: 15},
            {header: "Bộ phận xử lý", key: 'ok_name', width: 15},
            {header: "Số ngày xử lý", key: 'ok_day', width: 15},
            {header: "Nội dung xử lý", key: 'ok_content', width: 15},
          ];
          break;
        case 4:
          sheet = workbook.addWorksheet('Form 4');
          sheet.columns = [
            {header: "Số phiếu", key: 'no', width: 15},
            {header: "Ngày phản ánh", key: 'created_day', width: 15},
            {header: "Giờ nhận", key: 'created_hour', width: 15},
            {header: "Họ tên người liên hệ", key: 'name', width: 15},
            {header: "Số điện thoại của người liên hệ", key: 'phone', width: 15},
            {header: "Họ tên người cần hỗ trợ", key: 'needer_name', width: 15},
            {header: "Số điện thoại của người cần hỗ trợ", key: 'needer_phone', width: 15},
            {header: "Giới tính", key: 'needer_gender', width: 15},
            {header: "Năm sinh", key: 'needer_dob', width: 15},
            {header: "Nghề nghiệp", key: 'needer_job', width: 15},
            {header: "Quận/huyện", key: 'district', width: 15},
            {header: "Phường/xã", key: 'ward', width: 15},
            {header: "Địa chỉ người cần hỗ trợ", key: 'supportAddress', width: 15},
            {header: "Số lượng người/Hộ đang gặp khó khăn", key: 'peopleCount', width: 15},
            {header: "Nhu cầu cần hỗ trợ", key: 'type', width: 15},
            {header: "Nhu yếu phẩm bạn cần hỗ trợ gì?", key: 'htyp', width: 30},
            {header: "Vấn đề cần hỗ trợ (Mô tả cụ thể bằng lời)", key: 'content', width: 30},
            {header: "Có nằm trong vùng phong tỏa hay không", key: 'blockadeArea', width: 30},
            {header: "Trường hợp khẩn cấp", key: 'emergency', width: 30},
            {header: "Tên tình nguyện viên nghe cuộc gọi", key: 'user', width: 15},
          ];
          break;
        default:
          sheet = workbook.addWorksheet('Form 3 Tổng hợp');
          sheet.columns = [
            {header: "Số phiếu", key: 'no', width: 15},
            {header: "Ngày phản ánh", key: 'created_day', width: 15},
            {header: "Giờ nhận", key: 'created_hour', width: 15},
            {header: "Họ tên người liên hệ", key: 'name', width: 15},
            {header: "Số điện thoại của người liên hệ", key: 'phone', width: 15},
            {header: "Họ tên người cần hỗ trợ", key: 'needer_name', width: 15},
            {header: "Số điện thoại của người cần hỗ trợ", key: 'needer_phone', width: 15},
            {header: "Vấn đề cần hỗ trợ (Mô tả cụ thể bằng lời)", key: 'content', width: 30},
            {header: "Quận/huyện", key: 'district', width: 15},
            {header: "Phường/xã", key: 'ward', width: 15},
            {header: "Địa chỉ người cần hỗ trợ", key: 'supportAddress', width: 15},
            {header: "Nhu cầu cần hỗ trợ", key: 'type', width: 15},
            {header: "Số lượng người/Hộ đang gặp khó khăn", key: 'peopleCount', width: 15},
            {header: "Có nằm trong vùng phong tỏa hay không", key: 'blockadeArea', width: 30},
            {header: "Trường hợp khẩn cấp", key: 'emergency', width: 30},
            {header: "Trạng thái", key: 'status', width: 15},
          ];
          break;
      }
      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get(this.service, {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let local = this.getProvinceDistrictWard(item.provinceCode, item.districtCode, item.wardCode);
          //Hỗ trợ nhu yếu phẩm
          if (this.exportOptionModel.formType === 1 && item.type === 3) {
            sheet.addRow({
              no: item._id,
              created_day: moment(item.time).format('DD/MM/YYYY'),
              created_hour: moment(item.time).format('HH:mm:ss'),
              needer_name: item.needer_name ? item.needer_name : item.name,
              needer_phone: item.needer_number ? item.needer_number : item.number,
              peopleCount: item.peopleCount,
              district: local.district,
              ward: local.ward,
              supportAddress: item.supportAddress,
              htyp: item.htyp && item.htyp.length ? item.htyp.join(", ") : '',
              emergency: item.emergency ? 'Cần gấp' : 'Bình thường',
              blockadeArea: item.blockadeArea === 1 ? 'Có' : item.blockadeArea === 2 ? 'Không' : 'Không rõ',
            });
          } else if (this.exportOptionModel.formType === 2) {
            let row = {
              no: item._id,
              created_day: moment(item.time).format('DD/MM/YYYY'),
              created_hour: moment(item.time).format('HH:mm:ss'),
              needer_name: item.needer_name ? item.needer_name : item.name,
              needer_phone: item.needer_number ? item.needer_number : item.number,
              content: item.note,
              district: local.district,
              ward: local.ward,
              supportAddress: item.supportAddress,
              type: this.getType(item.type),
            }
            if (item.type === 4) {
              row.content2 = `[HT-09] Người dân báo: ${row.needer_name}, SĐT ${row.needer_phone}, nghề nghiệp ${item.job ? item.job : 'không rõ'}, cần được chính quyền địa phương hỗ trợ ${row.content}. Tại địa chỉ ${row.supportAddress}, ${local.ward}, ${local.district}`
            }
            if (item.type === 5) {
              row.content2 = `[HT-LĐ] Người dân báo: ${row.needer_name}, SĐT ${row.needer_phone}, thông báo ${row.content}. Tại địa chỉ ${row.supportAddress}, ${local.ward}, ${local.district}`
            }
            if (item.type === 0) {
              row.content2 = row.content
            }
            sheet.addRow(row);
          } else if (this.exportOptionModel.formType === 4) {
            let row = {
              no: item._id,
              created_day: moment(item.time).format('DD/MM/YYYY'),
              created_hour: moment(item.time).format('HH:mm:ss'),
              name: item.name,
              phone: item.number,
              needer_name: item.needer_name,
              needer_phone: item.needer_number,
              needer_gender: item.gender ? item.gender === 'unknown' ? 'Không rõ' : item.gender === 'male' ? 'Nam' : 'Nữ' : 'Không rõ',
              needer_dob: item.dob ? item.dob : this.$t('unknown'),
              needer_job: item.job ? item.job : 'không rõ',
              district: local.district,
              ward: local.ward,
              supportAddress: item.supportAddress,
              peopleCount: item.peopleCount,
              type: this.getType(item.type),
              htyp: item.htyp && item.htyp.length ? item.htyp.join(", ") : '',
              content: item.note,
              blockadeArea: item.blockadeArea === 1 ? 'Có' : item.blockadeArea === 2 ? 'Không' : 'Không rõ',
              emergency: item.emergency ? 'Khẩn cấp' : '',
              user: item.user ? `${item.user.name} - ${ item.user.ext } (${ item.user.email })` : '',
            }
            sheet.addRow(row);
          } else {
            sheet.addRow({
              no: item._id,
              created_day: moment(item.time).format('DD/MM/YYYY'),
              created_hour: moment(item.time).format('HH:mm:ss'),
              name: item.name,
              phone: item.number,
              needer_name: item.needer_name,
              needer_phone: item.needer_number,
              content: item.note,
              district: local.district,
              ward: local.ward,
              supportAddress: item.supportAddress,
              type: this.getType(item.type),
              peopleCount: item.peopleCount,
              blockadeArea: item.blockadeArea === 1 ? 'Có' : item.blockadeArea === 2 ? 'Không' : 'Không rõ',
              emergency: item.emergency ? 'Khẩn cấp' : '',
            });
          }
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'phan-anh.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    close() {
      this.cancelRequest = true;
    }
  },

}
</script>